module.exports = __webpack_public_path__ + "img/logo46.5a7f2cf2.png";